import {ssr_window} from "./ssr";

export const currentUrl = () => ssr_window.location.origin + ssr_window.location.pathname

export const getQueryObj = (str) => {
    if (!str) return {}
    let data = {},
        query_values = str.replace('?', '').split('&')
    query_values.forEach(query => {
        if (!query) return
        let [key, val] = query.split('=')
        data[key] = val
    })
    return data
}

export const getQueryVariable = (query, key) => {
    if (!key || !query) return ''
    return getQueryObj(query)[key] || ''
}

export const replaceInQuery = (str, key, val) => {
    let query_obj = getQueryObj(str),
        index = 0,
        new_query = ''
    query_obj[key] = val
    for (let [key, value] of Object.entries(query_obj)) {
        if (!!value) {
            new_query += `${index ? '&' : '?'}${key}=${value}`
            index++
        }
    }
    return new_query
}
